import React from 'react';
import { CircularProgress, Grid, Typography } from '@mui/material';
import { useGlobalization } from '@Translations';

interface CalculatedCostSummaryProps {
	value: string;
	breakdown: string;
	loading?: boolean;
}

export const CalculatedCostSummary = ({
	value,
	breakdown,
	loading = false,
}: CalculatedCostSummaryProps) => {
	const { t } = useGlobalization();
	return (
		<Grid xs={12} item>
			<Typography style={{ fontSize: '12px', color: '#4A6067' }}>
				{t('Calculated Total Cost')}
			</Typography>
			{loading ? (
				// Show a placeholder while the backend recalculates so the user
				// never sees a stale value flash and then change.
				<Grid
					container
					alignItems="center"
					spacing={1}
					style={{ marginTop: '4px' }}>
					<Grid item>
						<CircularProgress size={16} />
					</Grid>
					<Grid item>
						<Typography
							style={{ fontSize: '14px', color: '#768D95' }}>
							{t('Calculating…')}
						</Typography>
					</Grid>
				</Grid>
			) : (
				<>
					<Typography
						style={{
							fontSize: '20px',
							color: '#272833',
							fontWeight: 600,
						}}>
						{value}
					</Typography>
					<Typography style={{ fontSize: '12px', color: '#768D95' }}>
						{breakdown}
					</Typography>
				</>
			)}
		</Grid>
	);
};
